import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Icon } from '../header/draft/Icon';
import { useOpenApp } from '../../hooks/useOpenApp';
import './app-install-nudge.css';

/** 모바일(lg 미만) — 헤더 위 앱 설치 넛지 (Draft AppInstallNudge) */
export function AppInstallNudge() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const openApp = useOpenApp();

  if (pathname.startsWith('/auth') || pathname.startsWith('/app/membership')) {
    return null;
  }

  return (
    <div className="soundpill-app-install-nudge lg:hidden shrink-0 w-full">
      <button
        type="button"
        onClick={openApp}
        className="soundpill-app-install-nudge__link"
      >
        <span className="soundpill-app-install-nudge__icon-wrap">
          <Icon name="smartphone" className="text-primary text-lg" />
        </span>
        <span className="soundpill-app-install-nudge__text">
          <span className="soundpill-app-install-nudge__title">{t('layout.installNudgeTitle')}</span>
          <span className="soundpill-app-install-nudge__body">{t('layout.installNudgeBody')}</span>
        </span>
        <Icon name="chevron_right" className="text-primary shrink-0 text-xl" />
      </button>
    </div>
  );
}
